import { config } from "./config";

export const getFieldName = (key: string): string => {
  return config.metaFields[key] ?? key;
};
